// Forms UUID identities. Canonical lowercase hyphenated form. These mirror the
// Pydantic `ids.py` types and are a CHECKED CONSUMER of the generated JSON
// Schema under dashboard/ui/src/forms/generated — never an equal authority.

import { z } from 'zod';

export const UuidSchema = z
  .string()
  .regex(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/);

export type Uuid = z.infer<typeof UuidSchema>;

export const REJECT_CODES = [
  'schema_validation_failed',
  'form_id_mismatch',
  'version_conflict',
  'unknown_reference',
  'reference_conflict',
  'duplicate_id',
  'logic_cycle',
  'logic_type_mismatch',
  'invalid_navigation',
  'required_path_unreachable',
  'operation_integrity_conflict',
  'application_service_required',
] as const;

export type RejectCode = (typeof REJECT_CODES)[number];